(function ($) {
  "use strict";

  $(function () {
    if (!$(".js-discounted-apartments-slider").length) {
      return;
    }

    new Swiper(".js-discounted-apartments-slider", {
      slidesPerView: 1,
      spaceBetween: 20,
      speed: 400,
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: ".js-discounted-apartments-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1300: {
          slidesPerView: 4,
        },
      },
    });
  });
})(jQuery);
